export enum PagesEnum {
    oximeter = 1,
    bloodPressure = 2,
    thermometer = 3,
    glucometer = 4,
    finalizationScreen = 5,
}